import React from 'react';
import {BoxTitle} from "../BoxTitle";
import {TicketIcon} from "../TicketIcon";

export const CalendrierParticiper = () => {
  return (
    <div className="__front_box__">
      <BoxTitle title="Pour participer"/>

      <div className="text-center">
        Pour les sorties avec <span className="bold">location d'un véhicule</span> le club exige
        un <span className="bold">minimum de 7 personnes</span>, sinon la location sera annulée.<br/>
        Les participants <span className="underline">s'organiseront entre-eux</span> pour le déplacement.
        <br/><br/><br/>
        Pour une prise en charge par le club (Payée ou Subventionnée) il faut impérativement :
        <p className="text-warning bold">
          - Avoir une licence du club ou une carte de membre valide.<br/>
          - Porter le maillot du club lors de l'évènement  par respect pour nos sponsors.<br/>
          - S'inscrire via le site internet sur le calendrier prévu à cet effet en cliquant sur la case devant la date correspondante.<br/>
        </p>
        <span className="bold">Si l'une de ces 3 conditions n'étaient pas respectées, la participation du club sera caduque.</span>
        <br/><br/><br/>
        Pour rappel, les possesseurs de carte de membre bénéficient de <span className="bold">2 sorties</span> au choix dans le département
        et <span className="bold">1 sortie</span> hors département par année d'adhésion.<br/>
        Ils peuvent aussi <span className="underline">participer aux sorties exterieures</span>, suivant les
        places disponibles.
        Ne pas hésiter à <span className="bold">s'inscrire sur le calendrier.</span>
        <br/><br/>
        <span className="bold">Il sera possible de s'inscrire</span> en cliquant
        sur <TicketIcon /> se
        trouvant devant la <span className="underline">dâte correspondante.</span><br/>
      </div>
    </div>
  );
}
